import React, { useEffect, useState } from "react";

const SPRITE_URL = `${import.meta.env.BASE_URL}svg/sprite.svg`;

function spriteRef(iconId) {
  if (typeof window !== "undefined" && window.__CREDORA_SPRITE_READY__) {
    return `#${iconId}`;
  }
  return `${SPRITE_URL}#${iconId}`;
}

const SvgIcon = ({ iconId, width = 20, height = 20, ...rest }) => {
  const [, setReady] = useState(() => Boolean(window.__CREDORA_SPRITE_READY__));

  useEffect(() => {
    if (window.__CREDORA_SPRITE_READY__) {
      return undefined;
    }
    const onReady = () => setReady(true);
    window.addEventListener("credora-sprite-ready", onReady);
    return () => window.removeEventListener("credora-sprite-ready", onReady);
  }, []);

  if (!iconId) {
    return null;
  }

  const href = spriteRef(iconId);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} aria-hidden="true" {...rest}>
      <use href={href} xlinkHref={href} />
    </svg>
  );
};

export default SvgIcon;
